import _find from 'lodash/find'
import Moment from 'moment'
import { extendMoment } from 'moment-range'

const moment = extendMoment(Moment)

const dateFormat = 'MMM D, YYYY'

const createRange = (fromMoment, toMoment, asArray) => {
  if (asArray) {
    return [ fromMoment, toMoment ]
  }

  const from = fromMoment.format(dateFormat)
  const to = toMoment.format(dateFormat)

  return `${from} - ${to}`
}

const startOfToday = moment().startOf('day')
const endOfToday = moment().endOf('day')
const startOfSevenDaysAgo = moment().subtract(7, 'days').startOf('day')
const startOfYesterday = moment().subtract(1, 'days').startOf('day')
const endOfYesterday = moment().subtract(1, 'days').endOf('day')
const startOfThirtyDaysAgo = moment().subtract(30, 'days').startOf('day')
const startOfNinetyDaysAgo = moment().subtract(90, 'days').startOf('day')
const firstDayOfCurrentWeek = moment().startOf('week').startOf('day')
const firstDayOfCurrentMonth = moment().startOf('month').startOf('day')
const firstDayOfCurrentQuarter = moment().startOf('quarter').startOf('day')
const lastDayOfCurrentQuarter = moment().endOf('quarter').endOf('day')
const lastDayOfPreviousMonth = moment().subtract(1, 'month').endOf('month').endOf('day')
const firstDayOfPreviousMonth = moment().subtract(1, 'month').startOf('month').startOf('day')
const firstDayOfPreviousYear = moment().subtract(1, 'year').startOf('year').startOf('day')
const lastDayPreviousYear = moment().subtract(1, 'year').endOf('year').endOf('day')
const firstDayOfCurrentYear = moment().startOf('year').startOf('day')

const dateRanges = [
  {
    label: 'Today',
    array: createRange(startOfToday, endOfToday, true),
    value: createRange(startOfToday, endOfToday)
  },
  {
    label: 'Yesterday',
    array: createRange(startOfYesterday, endOfYesterday, true),
    value: createRange(startOfYesterday, endOfYesterday)
  },
  {
    label: 'Last 7 days',
    array: createRange(startOfSevenDaysAgo, endOfYesterday, true),
    value: createRange(startOfSevenDaysAgo, endOfYesterday)
  },
  {
    label: 'Last 30 days',
    array: createRange(startOfThirtyDaysAgo, endOfYesterday, true),
    value: createRange(startOfThirtyDaysAgo, endOfYesterday)
  },
  {
    label: 'Last 90 days',
    array: createRange(startOfNinetyDaysAgo, endOfYesterday, true),
    value: createRange(startOfNinetyDaysAgo, endOfYesterday)
  },
  {
    label: 'Last month',
    array: createRange(firstDayOfPreviousMonth, lastDayOfPreviousMonth, true),
    value: createRange(firstDayOfPreviousMonth, lastDayOfPreviousMonth)
  },
  {
    label: 'Last year',
    array: createRange(firstDayOfPreviousYear, lastDayPreviousYear, true),
    value: createRange(firstDayOfPreviousYear, lastDayPreviousYear)
  },
  {
    label: 'Week to date',
    array: createRange(firstDayOfCurrentWeek, endOfToday, true),
    value: createRange(firstDayOfCurrentWeek, endOfToday)
  },
  {
    label: 'Month to date',
    array: createRange(firstDayOfCurrentMonth, endOfToday, true),
    value: createRange(firstDayOfCurrentMonth, endOfToday)
  },
  {
    label: 'Quarter to date',
    array: createRange(firstDayOfCurrentQuarter, endOfToday, true),
    value: createRange(firstDayOfCurrentQuarter, endOfToday)
  },
  {
    label: 'Year to date',
    array: createRange(firstDayOfCurrentYear, endOfToday, true),
    value: createRange(firstDayOfCurrentYear, endOfToday)
  }
]

// Generate the last 4 quarters
for (let i of Array(4).keys()) {
  const firstDay = firstDayOfCurrentQuarter.clone().subtract(i, 'quarter')
  const lastDay = lastDayOfCurrentQuarter.clone().subtract(i, 'quarter')
  dateRanges.push(
    {
      label: firstDay.format('Qo [Quarter] (YYYY)'),
      array: createRange(firstDay, lastDay, true),
      value: createRange(firstDay, lastDay)
    }
  )
}

export const getRanges = () => {
  return dateRanges
}

export const getRange = (rangeLabel) => {
  const range = _find(dateRanges, { label: rangeLabel })

  return range
}



// WEBPACK FOOTER //
// ./src/js/utils/dateRanges.js